import { Cpu, Wallet } from 'lucide-react';

import { compact, sek } from '../../pages/weeklyreport/format';
import { type weeklyReportCost, type weeklyReportTokens } from '../../services/api/weekly-report';
import { KpiCard } from '../dashboard/KpiCard';

interface CostStatsProps {
  cost: weeklyReportCost;
  tokens: weeklyReportTokens;
  // Sant när hälsningarna är dolda men ändå ingår i veckans spend.
  greetingsExcludedFromView: boolean;
}

export const CostStats = ({ cost, tokens, greetingsExcludedFromView }: CostStatsProps) => (
  <>
    <div className="grid grid-cols-2 gap-4 sm:grid-cols-3">
      <KpiCard
        label="Totalt denna vecka"
        value={sek.format(cost.totalSek)}
        icon={<Wallet className="h-6 w-6" />}
      />
      <KpiCard
        label="Per chatt"
        value={sek.format(cost.perChatSek)}
        icon={<Wallet className="h-6 w-6" />}
      />
      <KpiCard
        label="Tokens denna vecka"
        value={compact.format(tokens.total)}
        icon={<Cpu className="h-6 w-6" />}
        description={`prompt ${compact.format(tokens.prompt)} · svar ${compact.format(
          tokens.completion,
        )} · cache ${compact.format(tokens.cached)}`}
      />
    </div>
    <p className="mt-2 text-xs text-slate-500">
      Växelkurs {cost.usdSekRate} USD/SEK.
      {greetingsExcludedFromView
        ? ' Totalen gäller veckans hela spend — hälsningarna kostade också pengar. Per chatt räknas på de visade chattarna.'
        : ''}
    </p>
  </>
);
